import script from "./RiskChange.vue?vue&type=script&setup=true&lang=js"
export * from "./RiskChange.vue?vue&type=script&setup=true&lang=js"

import "./RiskChange.vue?vue&type=style&index=0&id=50eb06aa&scoped=true&lang=scss"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50eb06aa"]])

export default __exports__